import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from "react";
import { CustomToast } from "../components/visuals/Toaster";
import ToastContainer from "react-bootstrap/ToastContainer";
import { Toast, ToastContextType, ToastType } from "../types/toastTypes";

export const ToastContext = createContext<ToastContextType | null>(null);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [currentToast, setCurrentToast] = useState<Toast | null>(null);

  const addToast = useCallback(
    (message: string, type: ToastType): void => {
      const id = Math.random();
      const onClose = (): void => setCurrentToast(null);
      const newToast: Toast = { id, message, type, onClose };
      setCurrentToast(newToast);
    },
    [],
  );

  const value = useMemo<ToastContextType>(() => ({ addToast }), [addToast]);

  return (
    <ToastContext.Provider value={value}>
      <ToastContainer className="p-3" position="top-end">
        {currentToast && (
          <CustomToast key={currentToast.id} {...currentToast} />
        )}
      </ToastContainer>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
